(() => {
  const key = "LuciaTravertineSections";
  const state = window[key] || { roots: [], frame: 0, ready: false };
  window[key] = state;
  const mobile = window.matchMedia("(max-width: 749px)");
  const reduce = window.matchMedia("(prefers-reduced-motion: reduce)");
  const refresh = () => { state.roots = [...document.querySelectorAll("[data-ltp-section]")].filter((el) => el.isConnected); };
  const renderRoot = (root) => {
    if (reduce.matches || window.Shopify?.designMode && root.hasAttribute("data-ltp-force-visible")) {
      root.classList.remove("ltp-is-future", "ltp-is-past");
      return;
    }
    const rect = root.getBoundingClientRect();
    const enter = Number(mobile.matches ? root.dataset.mobileTrigger : root.dataset.trigger) || 85;
    const exit = Number(mobile.matches ? root.dataset.mobileExit : root.dataset.exit) || 8;
    root.classList.toggle("ltp-is-future", rect.top > innerHeight * enter / 100);
    root.classList.toggle("ltp-is-past", rect.bottom < innerHeight * exit / 100);
  };
  const render = () => { state.frame = 0; refresh(); state.roots.forEach(renderRoot); };
  const schedule = () => { if (!state.frame) state.frame = requestAnimationFrame(render); };
  if (!state.ready) {
    addEventListener("scroll", schedule, { passive: true });
    addEventListener("resize", schedule, { passive: true });
    document.addEventListener("shopify:section:load", schedule);
    document.addEventListener("shopify:section:reorder", schedule);
    document.addEventListener("shopify:section:select", (event) => {
      event.target?.querySelector?.("[data-ltp-section]")?.scrollIntoView({ behavior: "smooth", block: "center" });
      schedule();
    });
    state.ready = true;
  }
  schedule();
})();